var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.conversation
    ? _c(
        "div",
        { style: { height: "100%" } },
        [
          _c(
            "w-card",
            {
              style: {
                height: "100%",
                marginBottom: "100px",
                borderRadius: "0",
              },
              nativeOn: {
                dragenter: function ($event) {
                  return _vm.onDragStart()
                },
                dragleave: function ($event) {
                  return _vm.onDragEnd()
                },
                drop: function ($event) {
                  return _vm.onFileDrop($event)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "header-bar", style: { display: "flex" } },
                [_vm._t("header")],
                2
              ),
              _c(
                "w-scroll-view",
                {
                  staticClass: "messages",
                  style: {
                    marginBottom: "0px",
                    paddingBottom: "0px",
                    height: "100%",
                  },
                  attrs: { tag: "w-card-content" },
                },
                [
                  _vm.conversation.Messages.length === 0
                    ? _c("div", { staticClass: "no-conversation" }, [
                        _vm._v(" " + _vm._s(_vm.$ct("no-conversation")) + " "),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.conversationGroups, function (group, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "group" },
                      [
                        _c("div", { staticClass: "seperator" }, [
                          _c("span", [_vm._v(_vm._s(group.Seperator))]),
                        ]),
                        _vm._l(group.Messages, function (thisMessage, index) {
                          return _c("app-chat-message", {
                            key: thisMessage.ID,
                            attrs: {
                              bubble: _vm.state.settings.BubbleStyle,
                              previous: group.Messages[index - 1],
                              value: thisMessage,
                            },
                          })
                        }),
                      ],
                      2
                    )
                  }),
                  _c("w-spacer"),
                ],
                2
              ),
              _c("w-card-actions", { style: { borderTop: "none" } }, [
                _c("div", { staticClass: "editor-wrapper" }, [
                  _c(
                    "div",
                    { attrs: { id: "editor-container" } },
                    [
                      _c("vue-editor", {
                        attrs: {
                          "editor-options": _vm.editorSettings,
                          "editor-toolbar": _vm.customToolbar,
                          placeholder: _vm.$ct("new-message"),
                        },
                        on: {
                          "text-change": function ($event) {
                            return _vm.onChange($event)
                          },
                        },
                        model: {
                          value: _vm.message,
                          callback: function ($$v) {
                            _vm.message = $$v
                          },
                          expression: "message",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("transition", { attrs: { name: "fast-fade" } }, [
                _vm.isDragging
                  ? _c("div", { staticClass: "file-overlay" }, [
                      _c(
                        "div",
                        [
                          _c("w-fa", {
                            attrs: { icon: "file-upload", size: "8x" },
                          }),
                        ],
                        1
                      ),
                      _c("div", [
                        _vm._v(_vm._s(_vm.$ct("drop-your-files-here"))),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }